import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
    'Copy .env.example to .env and fill in values.'
  );
}

export const supabase = createClient(url ?? '', anon ?? '', {
  auth: { persistSession: false },
});

export const EVENT_NAME = import.meta.env.VITE_EVENT_NAME ?? 'Larisa & Dani';
export const EVENT_DATE = import.meta.env.VITE_EVENT_DATE ?? '5 septembrie 2026';
export const EVENT_SUBTITLE = import.meta.env.VITE_EVENT_SUBTITLE ?? 'Împărtășește-ne momentele frumoase din seara nunții';
export const TELEGRAM_CHANNEL_NAME = import.meta.env.VITE_TELEGRAM_CHANNEL_NAME ?? '';

// Telegram config (citit la build time din .env sau Cloudflare env vars)
export const TELEGRAM_BOT_TOKEN = (import.meta.env.VITE_B_TOKEN as string | undefined) ?? '';
export const TELEGRAM_CHAT_ID = (import.meta.env.VITE_TELEGRAM_CHAT_ID as string | undefined) ?? '';
export const TELEGRAM_THREAD_ID = (import.meta.env.VITE_TELEGRAM_THREAD_ID as string | undefined) ?? '';
